<template>

  <BRow class="player_grid">
    <BCol md="6" lg="4" xl="4" sm="6" cols="6" v-for="player in players" :key="`player_${player.id}`" class="player_grid__item-wrapper p-1">
        <div class="player-item">
          <div class="player-item__image" v-if="!player.linked_list">
            <RouterLink :to="{ name: 'player.profile', params: { id: kebabCase(player.short_name) } }">
              <img :src="getPlayerImage(player.id)" class="img-avatar">
            </RouterLink>
          </div>

          <div class="player-item__image_multi"  v-if="player.linked_list && player.linked_list.length == 1">
            <RouterLink :to="{ name: 'player.profile', params: { id: kebabCase(player.short_name) } }">
              <img :src="getPlayerImage(player.id)" class="img-avatar">
              <div v-if="player.linked_list">
                <img v-for="r in player.linked_list" :key="`multiheader_${r.id}`" :src="getPlayerImage(r.id)" width="100%" class="relative-image" />
              </div>
            </RouterLink>
          </div>

          <div class="player-item__image" v-if="player.linked_list && player.linked_list.length > 1">
            <div class="">
              <div class="d-inline p-1" v-for="r in player.linked_list" :key="`multiheader_2_${r.id}`">
                <RouterLink :to="{ name: 'player.profile', params: { id: kebabCase(player.short_name) } }">
                  <img :src="getPlayerImage(r.id)" width="45%" class="img-relatives"/>
                </RouterLink>
              </div>
              <RouterLink :to="{ name: 'player.profile', params: { id: kebabCase(player.short_name) } }">
                <img :src="getPlayerImage(player.id)" width="45%" class="img-big">
              </RouterLink>
            </div>
          </div>

          <div class="player-item__country">
            <h6>
              {{ translateIsoCountry(player.country_iso_3) }}
            </h6>
          </div>
          <div class="player-item__meta text-left">
            <div>
              <h6 class="player-item__name m-0">
                <RouterLink :to="{ name: 'player.profile', params: { id: kebabCase(player.short_name) } }">
                  {{ player.title }}
                </RouterLink>
              </h6>
            </div>
            <div>
              <h3 class="player-item__title">
                <RouterLink :to="{ name: 'player.profile', params: { id: kebabCase(player.short_name) } }">
                  {{ player.short_name }}
                  <IconArrowRight class="d-none d-md-inline-block" :width="30" :height="30" />
                </RouterLink>
              </h3>
              <h5 v-if="player.sub_title" class="player-item__sub_title">
                <RouterLink :to="{ name: 'player.profile', params: { id: kebabCase(player.short_name) } }">
                  {{ player.sub_title }}
                </RouterLink>
              </h5>
            </div>
          </div>
          
        </div>
    </BCol>
  </BRow>
</template>

<script>

import kebabCase from 'lodash/kebabCase'
import utilsMixins from '@/mixins/utils'
import IconArrowRight from '@/components/IconArrowRight'

export default {
  name: "PlayersGrid",
  mixins: [utilsMixins],
  components: {
    IconArrowRight
  },
  props: {
    players: [Array]
  },
  methods: {
    kebabCase
  }
}
</script>

<style lang="scss">

.player_grid {
  width: 100%;
  margin: 0 auto;
  overflow-x: hidden;

  &__item-wrapper {
    padding: 0 15px;
  }

  .player-item {
    min-height: 190px;

    &__name {
      font-size: 18px;
      font-weight: 900;      

      a {
        color: var(--app-color-black);
      }
    }

    &__country {
      position: relative;
      top: -20px;
      max-width: 250px;
      background: var(--app-color-white);
      padding: 10px;

      h6 {
        font-size: 17px;
        color: var(--app-color-dark);
        margin: 0;
      }
    }
    &__linked-list {
      position: absolute;
      bottom: 25px;

      img {
        border-radius: 100%;
        background: var(--app-color-light);
      }
    }

    &__title {
      margin: 0;
      line-height: 21px;

      a {
        color: var(--app-color-red);
        font-size: 21px;
        line-height: 25px;
        font-weight: 900;
        width: 100%;
        max-width: 195px;
        display: block;
        margin-top: 5px;
        margin-bottom: 0px;
      }
    }

    &__sub_title {
      a {
        color: var(--app-color-black);
        font-size: 18px;
      }
    }

    &__meta {
      position: relative;
      width: 100%;
      top: -30px;
      padding: 5px 10px;
      max-width: 250px;
      background: var(--app-color-white);
    }

    &__image {
      position: relative;
      width: 100%;
      max-width: 250px;
      min-height: 230px;
      margin: 0 auto;

      @media (max-width: 767.98px) {
        position: relative;
        width: 100%;
        max-width: 250px;
        min-height: 170px;
      }

      .relative-image {
        position: relative;
        width: 100%;
        z-index: 99;
      }
    }

    &__image_multi {
      position: relative;
      width: 100%;
      max-width: 250px;
      min-height: 230px;
      padding-right: 10%;
      padding-bottom: 10%;

      @media (max-width: 767.98px) {
        position: relative;
        width: 100%;
        max-width: 250px;
        min-height: 170px;
      }
      
      .relative-image {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 50%;
        background: var(--app-color-black);
        border-radius: 100%;
        z-index: 99;
      }
    }
  }

  .img-big {
    border-radius: 100%;
    background: var(--app-color-black);
  }

  .img-relatives {
    border-radius: 100%;
    background: var(--app-color-coin);
  }

  .img-avatar {
    width: 90%;
    max-width: 250px;
    border-radius: 100%;
    background: var(--app-color-coin);
  }
}

</style>
